import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: string;
  reunionId?: string;
}

export function ProtectedRoute({ children, requiredRole, reunionId }: ProtectedRouteProps) {
  const { isAuthenticated, roles } = useAuthStore();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if (requiredRole) {
    const isSuperAdmin = roles.some(r => r.roleSlug === 'super_admin');
    const hasRequiredRole = roles.some(r =>
      r.roleSlug === requiredRole && (reunionId ? r.reunionId === reunionId : true)
    );

    if (!hasRequiredRole && !isSuperAdmin) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return <>{children}</>;
}
